import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/toPromise';
import { SxHttpService } from './sxHttp.service';

@Injectable()
export class CotizacionAsyncService {
  private url = 'api/cotizacionAsync';

  constructor(private sxHttp: SxHttpService) { }

  getCotizacionAsync(id,systemCode): Observable<any> {
    const url = `${this.url}/${id}/${systemCode}`;
    return this.sxHttp.get(url)
      .map(response => {
        return response.json().data;
      });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/services/cotizacionAsync.service.ts